import { useRef, useState, useEffect, Dispatch, SetStateAction } from 'react'
/* 
  useRefState is a custom hook that returns a ref object, a setter function and the current state value.
  The ref object is used to store the current state value and the setter function is used to update the state value.
  The ref object is updated whenever the state value changes.

  Why do we need this? 
    - MFEs can call parent function but if the these functions are using useState, the state value won't have the latest value.
    - Storing the value as a ref object will ensure that the value is always up to date.
*/

export const useRefState = <T>(
  initialValue: T,
): [React.MutableRefObject<T>, Dispatch<SetStateAction<T>>, T] => {
  const [state, setState] = useState(initialValue)
  const stateRef = useRef(state)

  useEffect(() => {
    stateRef.current = state
  }, [state])

  return [stateRef, setState, state]
}
